


export const hasOwnPropertyTS = <X extends object, Y extends PropertyKey>(obj: X, prop: Y): obj is X & Record<Y, unknown> => {
	return obj.hasOwnProperty(prop)
}

export const unknownHasOwnPropertyTS = <X extends unknown, Y extends PropertyKey>(obj: X, prop: Y): obj is X & Record<Y, unknown> => {
	return obj && typeof obj === 'object' && obj.hasOwnProperty(prop)
}


export const invalidFormValue = (value: unknown | null | undefined) => {
	if (value === null || value === undefined) return true;
	if (typeof value === 'string' && value === '') return true;
	if (typeof value === 'number' && value === 0) return true;
	if (Number.isNaN(value)) return true;
	return false;
}



export const isValidEmail = (email: string | null | undefined) =>
	email ? /^\S+@\S+\.\w+$/.test(email) : false;



export const isValidPhoneNumber = (numberString: string | null | undefined) =>
	numberString ? /\+?[\d\s]+\d$/.test(numberString) : false;

export const isValidUrl = (value: string) => {
	if (!value || value.length === 0) return false;
	if (!/^[A-Za-z0-9\-._~]+$/.test(value)) return false;
	return true;
};


export const isSpecificDelivery = (deliveryId: number, configIds: string) => {
	if (!deliveryId || !configIds) return false;

	const allIds = configIds.split(',');
	if (!allIds || allIds.length === 0) return false;

	return allIds.map(x => parseInt(x)).includes(deliveryId);
};


export function generateGuid(){
	let timeValue = new Date().getTime();
	let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		let r = (timeValue + Math.random() * 16) %16 | 0;
		timeValue = Math.floor(timeValue/16);
		return (c == 'x' ? r :(r&0x3|0x8)).toString(16);
	});
	return uuid;
}

export function isValidGuid(uuid: unknown) {
	if (!uuid || typeof uuid !== 'string') return false;
	const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	return regex.test(uuid);
}